<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('activities.activities')" @click="fire()" active>
              <data-table :edit-item="editItem" />
            </b-tab>

            <b-tab @click="fire()" :title="$t('site.add')">
              <my-form :new-item="newItem" :homeWork="homeWork" :exam="exam" />
            </b-tab>

          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>
<script>
import { subject } from '@casl/ability';
import DataTableVue from './components/DataTable.vue'
import FormVue from './components/Form.vue'
import SemesterController from "@/Controllers/SemesterController";
export default {
  name: 'ActivitiesIndex',
  components: {
    'data-table': DataTableVue,
    'my-form': FormVue,
  },
  data() {
    return {
      homeWork: [
        {
          question: "",
        },
        // {
        //   question:"",
        // },
        // {
        //   question:"",
        // },
      ],
      exam: [
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
      ],
      newItem: {},
      save_questions: false,
      tab: 0,
      newItemNew: {
        subjectCode: "",
        semesterCode: "",
        type: "",
        code: "",
        homework: "",
        homework_name: "",
        forum_name: "",
        description: "",
        education_level: "",
        from: "",
        to: "",
        homework_type: "",
        rate_type: "",
        subject: "",
        discussion: "",
        short_exam_name: "",
        period: "",
        period_type: "",
        attemps: "",
        allow: true,
        questions: [],
        edit : 0

      },
      controller: new SemesterController(),

      types: [],
      activitiesCodes: [],
      subjects: [],
      activities: [],

    }
  },
  created() {
    // console.log('df');
    // console.log(this.homeWork);
  },
  methods: {


    editItem(data) {

      this.form = true
      console.log(data.item)
      this.newItem = data.item
      if (data.item.type === 'homework') {
        if (data.item.questions.length > 0) {
          this.homeWork = data.item.questions;
        } else {
          this.homeWork = [
            {
              question: "",
            },
            // {
            //   question:"",
            // },
            // {
            //   question:"",
            // },
          ];
        }
      }
      if (data.item.type === 'exam') {
        if (data.item.questions.length > 0) {
          this.exam = data.item.questions;
        } else {
          this.exam = [
            {
              question: "",
              answers: [
                {
                  answer: '',
                  type: 0
                },
                {
                  answer: '',
                  type: 0
                }
              ]
            },
            {
              question: "",
              answers: [
                {
                  answer: '',
                  type: 0
                },
                {
                  answer: '',
                  type: 0
                }
              ]
            },
            {
              question: "",
              answers: [
                {
                  answer: '',
                  type: 0
                },
                {
                  answer: '',
                  type: 0
                }
              ]
            },
            {
              question: "",
              answers: [
                {
                  answer: '',
                  type: 0
                },
                {
                  answer: '',
                  type: 0
                }
              ]
            },
            {
              question: "",
              answers: [
                {
                  answer: '',
                  type: 0
                },
                {
                  answer: '',
                  type: 0
                }
              ]
            },
          ];
        }
      }
      if (data.item.type === 'forum' || data.item.type === 'short_search') {
        if (data.item.questions.length > 0) {
          this.newItem.forum_or_short_search = data.item.questions[0].question;
          console.log("manaa", this.newItem.forum_or_short_search);
        } else {
          this.newItem.forum_or_short_search = '';
        }
      }
      this.tab = 2;
    },
    fire() {
      this.save_questions = false;
      this.homeWork = [
        {
          question: "",
        },
        // {
        //   question:"",
        // },
        // {
        //   question:"",
        // },
      ];
      this.exam = [
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
        {
          question: "",
          answers: [
            {
              answer: '',
              type: 0
            },
            {
              answer: '',
              type: 0
            }
          ]
        },
      ];
      this.newItem = {};
    }
  },
}
</script>
